export interface FeatureFlags {
	IMAGE_LIBRARY: boolean;
	HIDE_ENDPOINT_MARKERS: boolean;
	PRICING_ENABLED: boolean;
	// Ticket 6, transport-lines.md — off in the agreed configuration, built behind this flag.
	ROUTE_LINE_CASING: boolean;
	PLACES_AUTOCOMPLETE_CASCADE: boolean;
}

const parseEnvBoolean = (value: string | undefined, defaultValue: boolean): boolean => {
	if (value === undefined || value === "") return defaultValue;
	return value.toLowerCase() === "true";
};

// Used as the initial/fallback values before Flagsmith responds, and in tests.
export const buildFeatureFlags = (): FeatureFlags => ({
	IMAGE_LIBRARY: parseEnvBoolean(import.meta.env.VITE_FEATURE_IMAGE_LIBRARY, false),
	HIDE_ENDPOINT_MARKERS: parseEnvBoolean(import.meta.env.VITE_FEATURE_HIDE_ENDPOINT_MARKERS, true),
	PRICING_ENABLED: parseEnvBoolean(import.meta.env.VITE_PRICING_ENABLED, false),
	ROUTE_LINE_CASING: parseEnvBoolean(import.meta.env.VITE_FEATURE_ROUTE_LINE_CASING, false),
	// work/places-autocomplete-cascade.md (WS1 P3) — kill switch for the own-first POI autocomplete
	// cascade in AddGooglePlace.tsx / dashboard/GooglePlaces.tsx. Off by default: falls back to the
	// existing Google-backed react-places-autocomplete path.
	PLACES_AUTOCOMPLETE_CASCADE: parseEnvBoolean(import.meta.env.VITE_FEATURE_PLACES_AUTOCOMPLETE_CASCADE, false),
});

export const featureFlags: FeatureFlags = buildFeatureFlags();

export default featureFlags;
